module.exports = __webpack_public_path__ + "assets/64c5cbbe27c42797cc333e3b3fb651e1.svg";